'use strict'
import axios from 'axios'

/* eslint-disable */

// axios example
// https://github.com/axios/axios

// service naming conventions
// https://restfulapi.net/resource-naming/
// -- use hyphens, not underscore, for readability

// axios tutorial
// https://medium.com/codingthesmartway-com-blog/getting-started-with-axios-166cb0035237
// video
// https://www.youtube.com/watch?v=1vbpBDWu1AQ

export default {
    getBook(bookCode) {
        let data = { c: bookCode }
        return axios.get('/api/book',{params: data}).then(res => res.data).catch(e => console.log(e) )
    },
    saveBookResponse(data) {
        return axios.post('/api/book-response',data).then(res => res.data).catch(e => console.log(e) )
    }
}


// WEBPACK FOOTER //
// ./src/service/service.js